import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../api-config";
import PrivateRoute from "../components/PrivateRoute";

import Dashboard from "../scenes/dashboard";
import Atr from "../scenes/atr";
import AtrDaily from "../scenes/atrDaily";
import Balanceador from "../scenes/balanceador";
import Home from "../scenes/home";
import TrackRecord from "../scenes/track_record";
import ForgotPassword from "../scenes/login/ForgotPassword";
import ChangePassword from "../scenes/login/ChangePassword";
import DemoBiReport from "../scenes/bi_report/demo";
import AdminPanel from "../scenes/admin_panel";
import SystemTrades from "../scenes/trades_sistema";
import GPT from "../scenes/gpt";
import BiReport from "../scenes/bi_report";
import CreateAgent from "../scenes/agents";
import Documentos from "../scenes/documentos";
import Databases from "../scenes/documentos/databases";
import AgentsDashboard from "../scenes/agents/dashboard";
import RiskCalculator from "../scenes/risk";
import Indicators_Summary from "../scenes/indicators_summary";
import AgentDetail from "../scenes/agents/detail";
import UserDashboard from "../modules/users/UserDashboard";
import UserDetail from "../modules/users/UserDetail";
import UserCreate from "../modules/users/Create";
import UserMe from "../modules/users/UserMe";
import Latam from "../scenes/latam";
import BlogPost from "../scenes/posts";
import CreateBlogPost from "../scenes/posts/CreateBlogPost";
import PostDetail from "../scenes/posts/PostDetail";
import SpreadManager from "../scenes/spread";
// import SpreadRule from "../scenes/spread/SpreadRule";
import AccountsList from "../scenes/reports";
import TradeDashboard from "../scenes/reports/TradeDashboard";
// import NoResidentes from "../scenes/macro/NoResidentes";
import Indicators from "../scenes/indicators";
import UploadReport from "../scenes/reports/UploadReport";
import Drivers from "../scenes/drivers";
import SSEDashboard from "../scenes/reports/SSEDashboard";
import SmartBands from "../scenes/smart_bands";
import MarkovComponents from "../scenes/markov_components";
import PriceFeed from "../scenes/price_feed";
import PriceMonitor from "../scenes/price_monitor";
import FixClient from "../scenes/fix_client";
import OrderBookView from "../scenes/orderbook";
import TickControl from "../scenes/tick_control";

function RouterComponent({ token, theme }) {
  const { email, valid_token } = useParams();
  const [roles, setRoles] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(true);

  useEffect(() => {
    if (!token) return;
    axios
      .get(`${API_URL}/users-api/me`, {
        headers: {
          accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        const getRoles = response.data.roles || [];
        setRoles(getRoles);
        setLoadingRoles(false);
      })
      .catch(() => setLoadingRoles(false));
  }, [token]);

  if (token && loadingRoles) {
    return <div className="text-white text-center mt-20">Cargando permisos...</div>;
  }

  return (
    <Routes>
      <Route path="/" element={token ? <Dashboard /> : <Home theme={theme} />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute token={token} roles={roles}>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/atr"
        element={
          <PrivateRoute token={token} roles={roles}>
            <Atr />
          </PrivateRoute>
        }
      />
      <Route
        path="/atr_daily"
        element={
          <PrivateRoute token={token} roles={roles}>
            <AtrDaily />
          </PrivateRoute>
        }
      />
      <Route
        path="/track_record"
        element={
          <PrivateRoute token={token} roles={roles}>
            <TrackRecord />
          </PrivateRoute>
        }
      />
      <Route
        path="/forgot_password"
        element={!token ? <ForgotPassword /> : <Navigate replace to="/" />}
      />
      <Route
        path="/reset_password/:email/:valid_token"
        element={
          !token ? (
            <ChangePassword email={email} valid_token={valid_token} />
          ) : (
            <Navigate replace to="/" />
          )
        }
      />
      <Route
        path="/balanceador"
        element={
          <PrivateRoute token={token} roles={roles}>
            <Balanceador />
          </PrivateRoute>
        }
      />
      <Route
        path="/indicator"
        element={
          <PrivateRoute token={token} roles={roles} allowedRoles={["Manager"]}>
            <Indicators />
          </PrivateRoute>
        }
      />
      <Route
        path="/drivers"
        element={
          <PrivateRoute token={token} roles={roles}>
            <Drivers />
          </PrivateRoute>
        }
      />
      <Route
        path="/indicadores"
        element={
          <PrivateRoute token={token} roles={roles}>
            <Indicators_Summary token={token} />
          </PrivateRoute>
        }
      />
      <Route path="/sixbell_bi" element={<BiReport id="4f689b8b-bf1a-4396-949d-2b9428abade0" />} />
      <Route path="/demo_bi/:id" element={<DemoBiReport />} />
      <Route
        path="/latam"
        element={
          <PrivateRoute token={token} roles={roles}>
            <Latam />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin_panel"
        element={
          <PrivateRoute token={token} roles={roles} allowedRoles={["Admin", "Manager"]}>
            <AdminPanel />
          </PrivateRoute>
        }
      />
      <Route
        path="/trades_sistema"
        element={
          <PrivateRoute token={token} roles={roles}>
            <SystemTrades />
          </PrivateRoute>
        }
      />
      <Route
        path="/gpt/:id"
        element={
          <PrivateRoute token={token} roles={roles}>
            <GPT />
          </PrivateRoute>
        }
      />
      <Route
        path="/agentes/crear"
        element={
          <PrivateRoute token={token} roles={roles} allowedRoles={["AgentCreator", "Admin"]}>
            <CreateAgent />
          </PrivateRoute>
        }
      />
      <Route
        path="/agentes/documentos"
        element={
          <PrivateRoute token={token} roles={roles}>
            <Documentos />
          </PrivateRoute>
        }
      />
      <Route
        path="/agentes/bdd"
        element={
          <PrivateRoute token={token} roles={roles}>
            <Databases />
          </PrivateRoute>
        }
      />
      <Route
        path="/agentes/dashboard"
        element={
          <PrivateRoute token={token} roles={roles}>
            <AgentsDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/risk"
        element={
          <PrivateRoute token={token} roles={roles}>
            <RiskCalculator />
          </PrivateRoute>
        }
      />
      <Route
        path="/agentes/detail/:id"
        element={
          <PrivateRoute token={token} roles={roles}>
            <AgentDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/posts"
        element={
          <PrivateRoute token={token} roles={roles}>
            <BlogPost />
          </PrivateRoute>
        }
      />
      <Route
        path="/posts/create"
        element={
          <PrivateRoute token={token} roles={roles} allowedRoles={["Admin", "Editor"]}>
            <CreateBlogPost />
          </PrivateRoute>
        }
      />
      <Route
        path="/posts/:id"
        element={
          <PrivateRoute token={token} roles={roles}>
            <PostDetail />
          </PrivateRoute>
        }
      />
      <Route path="/trading-accounts" element={
        <PrivateRoute token={token} roles={roles} allowedRoles={["Manager", "Admin"]}>
          <AccountsList />
        </PrivateRoute>

      } />
      <Route path="/upload-report" element={
        <PrivateRoute token={token} roles={roles} allowedRoles={["Manager", "Admin"]}>
          <UploadReport />
        </PrivateRoute>

      } />
      <Route path="/report/:id" element={
        <PrivateRoute token={token} roles={roles} allowedRoles={["Manager", "Admin"]}>
          <TradeDashboard />
        </PrivateRoute>

      } />
      {/* <Route path="/no_residentes" element= {
        <PrivateRoute token={token} roles={roles} allowedRoles={["Manager", "Admin"]}>
          <NoResidentes/>
        </PrivateRoute>

      }/> */}

      <Route path="/users/panel" element={<PrivateRoute token={token} roles={roles} allowedRoles={["Admin"]}>
        <UserDashboard />
      </PrivateRoute>} />
      <Route path="/users/info/:id" element={<PrivateRoute token={token} roles={roles} allowedRoles={["Admin"]}>
        <UserDetail />
      </PrivateRoute>} />
      <Route path="/users/create" element={<PrivateRoute token={token} roles={roles}>
        <UserCreate />
      </PrivateRoute>} />
      <Route path="/users/me" element={<UserMe />} />
      <Route
        path="/spread"
        element={
          <PrivateRoute token={token} roles={roles} allowedRoles={["Manager"]}>
            <SpreadManager />
          </PrivateRoute>
        }
      />
      <Route
        path="/report-live"
        element={
          <PrivateRoute token={token} roles={roles} allowedRoles={["Manager"]}>
            <SSEDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/smart_bands"
        element={
          <PrivateRoute token={token} roles={roles}>
            <SmartBands />
          </PrivateRoute>
        }
      />
      <Route
        path="/markov_components"
        element={
          <PrivateRoute token={token} roles={roles}>
            <MarkovComponents />
          </PrivateRoute>
        }
      />
      <Route
        path="/price_feed"
        element={
          <PrivateRoute token={token} roles={roles}>
            <PriceFeed />
          </PrivateRoute>
        }
      />
      <Route
        path="/price_monitor"
        element={
          <PrivateRoute token={token} roles={roles}>
            <PriceMonitor />
          </PrivateRoute>
        }
      />
      <Route
        path="/orderbook"
        element={
          <PrivateRoute token={token} roles={roles}>
            <OrderBookView />
          </PrivateRoute>
        }
      />
      <Route
        path="/fix-client"
        element={
          <PrivateRoute token={token} roles={roles} allowedRoles={["Manager", "Admin"]}>
            <FixClient />
          </PrivateRoute>
        }
      />
      <Route
        path="/tick-control"
        element={
          <PrivateRoute token={token} roles={roles} allowedRoles={["Manager", "Admin"]}>
            <TickControl />
          </PrivateRoute>
        }
      />

      {/* <Route
        path="/spread/rules"
        element={
          <PrivateRoute token={token} roles={roles} allowedRoles={["Manager"]}>
            <SpreadRule />
          </PrivateRoute>
        }
      /> */}
    </Routes>
  );
}

export default RouterComponent;
